import { type FC, type ReactNode, useEffect, useState } from 'react';

import { Content } from '@vakantiesnl/components/src/atoms/Content';
import { BreadCrumbs } from '@vakantiesnl/components/src/molecules/BreadCrumbs';
import { breadCrumbsCreator } from '@vakantiesnl/services/src/util/breadCrumbsCreator';
import { type BreadCrumbItem, type ContentTemplate } from '@vakantiesnl/types';

import { useStyles } from './AccountWrapper.style';
import { MainMenu } from './MainMenu';
import { SubMenu } from './Submenu';

type Props = {
	children: ReactNode;
	pageContent: ContentTemplate;
	bookingNumber?: number;
};

/** Wraps the Mijn Zoover/account pages, adds breadcrumbs and menu (sidebar on desktop, drawer on mobile). */
export const AccountWrapper: FC<Props> = ({ children, pageContent, bookingNumber }) => {
	const { classes } = useStyles();

	const [breadCrumbs, setBreadCrumbs] = useState<BreadCrumbItem[] | undefined>(undefined);

	const { seo } = pageContent;

	useEffect(() => {
		breadCrumbsCreator(seo.slug, bookingNumber?.toString()).then((newBreadCrumbs) =>
			setBreadCrumbs(newBreadCrumbs),
		);

		// Update breadcrumbs only when the slug changes
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [seo.slug]);

	return (
		<>
			<Content fullHeight>
				{!!breadCrumbs && <BreadCrumbs className={classes.breadcrumbs} breadcrumbs={breadCrumbs} />}
				<div className={classes.accountLayout}>
					<div className={classes.menu} data-cy="accountMenu">
						{bookingNumber ? <SubMenu bookingNumber={bookingNumber} /> : <MainMenu />}
					</div>
					<div className={classes.pageContent}>{children}</div>
				</div>
			</Content>
		</>
	);
};
